<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <!-- Pages -->
  <router-outlet></router-outlet>
  <!-- <app-footer></app-footer> -->
</div>
